/** PURE_IMPORTS_START .._.._Observable,.._.._observable_forkJoin PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { forkJoin as staticForkJoin } from '../../observable/forkJoin';
Observable.forkJoin = staticForkJoin;
//# sourceMappingURL=forkJoin.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/observable/forkJoin.js
// module id = ./node_modules/rxjs/_esm5/add/observable/forkJoin.js
// module chunks = vendor